import SummaryTiles from './SummaryTiles';

export default SummaryTiles;
